import Styles from 'assets/Styles';
import Funcs from 'common/helpers/Funcs';
import AdsConst from 'consts/AdsConst';
import AppConst from 'consts/AppConst';
import StorageConst from 'consts/StorageConst';
import moment from 'moment';
import React from 'react';
import { View } from 'react-native';
import mobileAds, { AdEventType, AppOpenAd, BannerAd, BannerAdSize, InterstitialAd } from 'react-native-google-mobile-ads';
import AppContextView from 'states/context/views/AppContextView';
import Configs from 'utils/Configs';
import StorageService from './StorageService';

class AdmobBanner extends AppContextView {
  onBannerLoaded = () => {
    Funcs.log('Banner loaded!');
  };

  onBannerFailedToLoad = (e) => {
    const { code, message } = e;
    Funcs.log('Banner load faild', { code, message });
  };

  render() {
    const { removeAds } = this.context || {};
    if (removeAds) return null;
    return <BannerAd unitId={AdsConst.ADMOB.BANNER} {...this.props} onAdLoaded={this.onBannerLoaded} onAdFailedToLoad={this.onBannerFailedToLoad} />;
  }
}

var loaded = false;
var interstitial;
var openAds;

const AdmobService = {
  eventCount: 0,

  init: async () => {
    Funcs.log('AdmobService init');
    await mobileAds().initialize();
  },

  requestOpenAds: () => {
    if (!openAds) openAds = AppOpenAd.createForAdRequest(AdsConst.ADMOB.OPEN, { requestNonPersonalizedAdsOnly: true });
    openAds.load();
    openAds.addAdEventListener(AdEventType.LOADED, () => {
      loaded = true;
    });
    openAds.addAdEventListener(AdEventType.CLOSED, () => {
      loaded = false;
      openAds.load();
    });
  },

  showReward: (callback) => {},

  requestFullAds: () => {
    if (!Configs.adsEnable || loaded) return;
    Funcs.log('Request Full Ads');
    if (!interstitial) interstitial = InterstitialAd.createForAdRequest(AdsConst.ADMOB.FULL);
    interstitial.load();
    interstitial.addAdEventListener(AdEventType.LOADED, () => {
      loaded = true;
    });
    interstitial.addAdEventListener(AdEventType.CLOSED, () => {
      loaded = false;
      interstitial.load();
    });
  },

  showFullAds: async () => {
    if (!Configs.adsEnable) return;
    AdmobService.eventCount++;
    if (!loaded) {
      AdmobService.requestFullAds();
      Funcs.log('AdmobService not available');
      return;
    }

    // Check time
    Funcs.log('AdmobService.eventCount', AdmobService.eventCount);
    if (AdmobService.eventCount < (Configs.fullAdsMaxEventCount || 6)) return;

    // Show
    Funcs.log('AdmobService show Full');
    interstitial?.show();
    AdmobService.eventCount = 0;
  },

  showOpenAds: async () => {
    // Android không dùng quảng cáo mở app, chỉ dùng quảng cáo full
    if (!Configs.adsEnable || AppConst.IS_ANDROID) return;

    // Check user sử dụng trên 10 ngày mới hiển thị
    if (Configs.user?.createdAt) {
      const time = (Date.now() - moment(Configs.user?.createdAt).valueOf()) / 1000;
      if (time < 10 * 24 * 60 * 60) {
        Funcs.log('Cancel show ads for this user', Configs.user?.createdAt);
        return;
      }
    }

    // Đếm
    AdmobService.eventCount++;
    StorageService.save(StorageConst.ADS_EVENT_COUNT, AdmobService.eventCount);
    if (!loaded) {
      AdmobService.requestOpenAds();
      Funcs.log('AdmobService not available');
      return;
    }

    // Check time
    Funcs.log('AdmobService.eventCount', AdmobService.eventCount);
    if (AdmobService.eventCount < (Configs.fullAdsMaxEventCount || 6)) return;

    // Show
    Funcs.log('AdmobService show Full');
    openAds?.show();
    AdmobService.eventCount = 0;
  },

  renderBanner: (size: BannerAdSize = BannerAdSize.ANCHORED_ADAPTIVE_BANNER) => {
    if (!Configs.adsEnable) return null;
    return <AdmobBanner size={size} />;
  },

  renderRectBanner: (size: BannerAdSize = BannerAdSize.MEDIUM_RECTANGLE) => {
    if (!Configs.adsEnable) return null;
    return (
      <View style={Styles.center}>
        <AdmobBanner size={size} />
      </View>
    );
  },

  release: () => {
    if (interstitial) interstitial.removeAllListeners();
  }
};

export default AdmobService;
